const COOKIE_CLEAR_PATHS = ["/", "/api/v1/auth"];
const SHARED_AUTH_COOKIE_DOMAIN = ".execbridge.ai";

const getCookieClearDomains = (hostname: string): string[] => {
  const domains = [hostname];

  if (hostname === "localhost" || hostname.endsWith(".localhost")) {
    return domains;
  }

  if (hostname === "execbridge.ai" || hostname.endsWith(".execbridge.ai")) {
    domains.push(SHARED_AUTH_COOKIE_DOMAIN);
  }

  return domains;
};

/**
 * Expire all cookies readable from JavaScript (csrf_token, PostHog, etc.).
 * HttpOnly cookies (e.g. refresh_token) are cleared by the logout API response.
 */
export const clearClientAccessibleCookies = (): void => {
  if (typeof document === "undefined" || !document.cookie) return;

  const names = document.cookie
    .split(";")
    .map(part => part.split("=")[0]?.trim())
    .filter((name): name is string => Boolean(name));

  const domains = getCookieClearDomains(window.location.hostname);

  for (const name of names) {
    for (const path of COOKIE_CLEAR_PATHS) {
      for (const domain of domains) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
      }
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
    }
  }
};
